// extracted by mini-css-extract-plugin
export default {"accessDenied":"AccessDenied_accessDenied__dGOfa","logo":"AccessDenied_logo__THqn7"};